import { POST } from "./_config";

export const changeSuperAdminPasswordApi = async (userId: string, body: any) =>
  await POST(`/super-admin/user/change-password/${userId}`, body, true);
